export default __webpack_public_path__ + "static/media/arrow-right.fe519cf4.svg";